import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Container } from '../../../ui/gridSystem';
import { Badge, HtmlRaw, Text } from '../../../ui/atoms';
import { Cover, Date, InfoWrapper } from './style';
import routes from '../../../routes';
import Breadcrumb from '../../../ui/atoms/Breadcrumb';
import {
  NOTIFICATION_DETAILS_GET,
  NOTIFICATION_DETAILS_RESET,
} from '../../redux/actions/notifications';
import {
  replaceCourseSubstrings,
  getLabelByType,
} from '../../../utils/notifications';

const NotificationDetails = ({
  data,
  getNotificationDetails,
  notificationReset,
}) => {
  const { notification_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    getNotificationDetails(notification_id);

    return () => notificationReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification_id]);

  const onClickCrumb = () => navigate(routes.notifications.path);

  const addNotificationLink = (body) => {
    if (!body) return '';
    const parsedBody = replaceCourseSubstrings({
      input: body,
      hasLink: true,
    });

    return parsedBody;
  };

  useEffect(() => {
    const links = document.querySelectorAll('[id^="link-"]');

    links.forEach((link) => {
      link.addEventListener('click', handleClick);
    });

    function handleClick(e) {
      e.preventDefault();
      const id = e.currentTarget.getAttribute('data-id');
      if (id) {
        navigate(`${routes.courseDetails.path}/${id}/panoramica`);
      }
    }

    // Cleanup
    return () => {
      links.forEach((link) => {
        link.removeEventListener('click', handleClick);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.body]);

  return (
    <>
      <Breadcrumb
        crumbs={[
          { label: 'Notifiche', onClick: onClickCrumb },
          { label: data?.title },
        ]}
      />
      <Container className="pt-0">
        <Text type="h1" mb={data?.coverUrl ? 8 : 24}>
          {data?.title}
        </Text>
        {data?.subtitle && (
          <Text type="b3" mb={24}>
            {data?.subtitle}
          </Text>
        )}
        {data?.coverUrl && <Cover src={data.coverUrl} />}
        <InfoWrapper>
          <Badge type="news">{getLabelByType(data)}</Badge>
          {data?.created && (
            <Date>
              <Text type="b4">
                {dayjs(data.created * 1000).format('DD/MM/YYYY')}
              </Text>
            </Date>
          )}
        </InfoWrapper>
        <Text type="b3" mb={80}>
          <HtmlRaw html={addNotificationLink(data?.body)} />
        </Text>
      </Container>
    </>
  );
};

NotificationDetails.propTypes = {
  data: PropTypes.object,
  getNotificationDetails: PropTypes.func,
  notificationReset: PropTypes.func,
};

export default connect(
  (state) => {
    const { details: data } = state.notifications;
    return {
      data,
    };
  },
  (dispatch) => ({
    getNotificationDetails: (id) =>
      dispatch({ type: NOTIFICATION_DETAILS_GET._REQUEST, id }),
    notificationReset: () => dispatch({ type: NOTIFICATION_DETAILS_RESET }),
  })
)(NotificationDetails);
